export const REACT_APP_API_HOST =
  process.env.REACT_APP_API_HOST || 'https://tospapimgmt.azure-api.net';
